/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Blockstatusinprogress3Inputs */

const zh_learn_blockstatusinprogress3 = /** @type {(inputs: Learn_Blockstatusinprogress3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进行中`)
};

const en_learn_blockstatusinprogress3 = /** @type {(inputs: Learn_Blockstatusinprogress3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in progress`)
};

const es_learn_blockstatusinprogress3 = /** @type {(inputs: Learn_Blockstatusinprogress3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`en progreso`)
};

/**
* | output |
* | --- |
* | "in progress" |
*
* @param {Learn_Blockstatusinprogress3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_blockstatusinprogress3 = /** @type {((inputs?: Learn_Blockstatusinprogress3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Blockstatusinprogress3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_blockstatusinprogress3(inputs)
	if (locale === "en") return en_learn_blockstatusinprogress3(inputs)
	return es_learn_blockstatusinprogress3(inputs)
});
export { learn_blockstatusinprogress3 as "learn_blockStatusInProgress" }